import { useState } from 'react'
import { Banner, Button, Form, Heading } from '@boltenergy-be/design-system'
import { FormProvider, useForm } from 'react-hook-form'
import { useTranslation } from 'next-i18next/pages'
import { useRouter } from 'next/router'
import { LeaveInfoDuringDowntimeFormInputs } from './types'
import { Email, FirstName, LastName, Phone } from 'components/inputs'

const LeaveInfoDuringDowntimeStep = () => {
  // Local state
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [success, setSuccess] = useState<boolean>(false)

  // Next Router
  const { locale } = useRouter()

  // i18n
  const { t } = useTranslation(['simulation', 'commonFormFields'])

  // React Hook Form
  const hookForm = useForm<LeaveInfoDuringDowntimeFormInputs>({
    mode: 'onChange'
  })
  const {
    formState: { isDirty, isValid },
    handleSubmit
  } = hookForm

  /**
   * Handles the submit after validation
   *
   * @param data
   */
  const onSubmit = async (data: LeaveInfoDuringDowntimeFormInputs) => {
    setIsLoading(true)

    const { firstName, lastName, email, mobilePhone } = data

    const formData = new FormData()
    formData.append('firstName', firstName)
    formData.append('lastName', lastName)
    formData.append('email', email)
    formData.append('language', locale)
    formData.append('phone', mobilePhone || '')

    await fetch('https://hooks.zapier.com/hooks/catch/5187268/bmo6rru', {
      body: formData,
      method: 'POST',
      mode: 'no-cors'
    })

    setSuccess(true)
    setIsLoading(false)
  }

  return (
    <>
      <Heading as="h1" variant="h4">
        {t('simulation:systemDown.title')}
      </Heading>
      <p>{t('simulation:systemDown.description')}</p>

      <FormProvider {...hookForm}>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <FirstName />

          <LastName />

          <Email />

          <Phone />

          <Form.Footer>
            <Button loading={isLoading} disabled={success || !isDirty || !isValid}>
              {t('common:send')}
            </Button>
            {success && <Banner type="positive">{t('simulation:systemDown.success')}</Banner>}
          </Form.Footer>
        </Form>
      </FormProvider>
    </>
  )
}

export default LeaveInfoDuringDowntimeStep
